// extracted by mini-css-extract-plugin
export default {"form":"RffCr3t2","mobile":"mobile","row":"LvwMVKbu","codeSender":"zzXoP47V","field":"Yq7Pb0Z2","phoneConfirm":"X9l_TFQf"};